import {
  MANAGE_ACTION,
  SNAPSHOT_APPROVER,
  DASHBOARD_BANNER,
  READ_ACTION,
  PROFILE,
  CREATE_ACTION,
  BUSINESS_UNIT,
} from "@/constants/resources";

export default [
  {
    title: "Configurações",
    icon: "none",
    children: [
      {
        title: "Aprovadores de snapshot",
        route: "snapshot-approvers-list",
        icon: "UserCheckIcon",
        resource: SNAPSHOT_APPROVER,
        action: MANAGE_ACTION,
      },
      {
        title: "Perfis de acesso",
        route: "access-profiles-list",
        icon: "ListIcon",
        resource: PROFILE,
        action: CREATE_ACTION,
      },
      {
        title: "Banners",
        route: "dashboard-banners",
        icon: "ImageIcon",
        resource: DASHBOARD_BANNER,
        action: READ_ACTION,
      },
      {
        title: "Unidades de negócio",
        route: "business-units-list",
        icon: "BriefcaseIcon",
        resource: BUSINESS_UNIT,
        action: READ_ACTION,
      },
    ],
  },
];
